'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * Details content component, contains the content of the details item.
 *
 * @example
 * <DetailsContent>Content</DetailsContent>
 */
const DetailsContent = forwardRef(function DetailsContent(rest, ref) {
    return jsx("div", { ref: ref, ...rest });
});

export { DetailsContent };
